export default __webpack_public_path__ + "static/GRID2022 Stock Disasters RGBlight - Simplify-01-e71c7992cd6bc6b2975681c52d91cdba.svg";